var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "575d0f7b823b02389b3e9dd7805eae145b7326dc"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["trees-online@better-place-forests-org"] = {
  id: "575d0f7b823b02389b3e9dd7805eae145b7326dc"
};